import api from '@pray/shared/utils/api';

export type RemoveSpendRampParams = {
  artistId: string;
  campaignId: string;
  spendRampId: string;
};

export const removeSpendRamp = async ({ artistId, campaignId, spendRampId }: RemoveSpendRampParams) => {
  const url = `/web/studio/artists/${artistId}/marketing-campaigns/${campaignId}/spend-ramps/${spendRampId}`;

  const response = await api.executeDeleteRequest(url);

  return response.data;
};
